import React from "react";
import Router from "./routes/Routes";

const App = () => <Router />;

export default App;
